import React from 'react'
import {useSelector} from 'react-redux'
import ModalHeaderAtom from '../../@atoms/to_layout/modal_header/modal_header.atom'
import TypographyAtom from '../../@atoms/to_content/typography/typography.atom'
import {RootState} from '../../store_redux'

const DateSelectionModalHeaderComponent: React.FC = function () {
  const rootState = useSelector((state: RootState) => state)
  const {labels, modal} = rootState

  const {action, orderType} =
    modal.type === 'BEST_DATE'
      ? {
          action: modal.data.bestDate.type || '',
          orderType: modal.data.bestDate.visitType,
        }
      : {
          action: modal.data.standardDateChoice.type || '',
          orderType: modal.data.standardDateChoice.visitType,
        }

  const title = /CHANGE|RESCHEDULE/i.test(action || '')
    ? labels.bookDateModal.titleForReschedule[
        orderType?.toLowerCase() as keyof typeof labels.bookDateModal.titleForReschedule
      ]
    : labels.bookDateModal.title[
        orderType?.toLowerCase() as keyof typeof labels.bookDateModal.title
      ]

  return (
    <ModalHeaderAtom ap_type="book_date_modal">
      <TypographyAtom ahd_type="h6">{title}</TypographyAtom>
    </ModalHeaderAtom>
  )
}

export default DateSelectionModalHeaderComponent
